module.exports = __webpack_public_path__ + "static/img/one-book.78cd5ba1.png";